import type React from 'react';
import { useFeatureEnabled } from '../hooks/useFeatureEnabled';

interface FeatureGateProps {
  featureKey: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  hideWhileLoading?: boolean;
  inverted?: boolean;
}

const FeatureGate: React.FC<FeatureGateProps> = ({
  featureKey,
  children,
  fallback = null,
  hideWhileLoading = true,
  inverted = false
}) => {
  const { data, isLoading, isError } = useFeatureEnabled(featureKey);

  if (isLoading && hideWhileLoading) return <>{fallback}</>;
  if (isError) return <>{fallback}</>;
  
  const isEnabled = data?.featureFlag?.enabled ?? false;
  const shouldShow = inverted ? !isEnabled : isEnabled;
  
  if (shouldShow) return <>{children}</>;
  return <>{fallback}</>;
};

export default FeatureGate;
